
import qs from 'qs'
import vueQr from 'vue-qr'
import TCaptcha from '@/utils/TCaptcha'
export default {
  name: 'Setup',
  data() {
    return {
      showWxdialog: false,
      // 绑定邮箱对话框
      showMailDialog: false,
      // 绑定手机对话框
      showTelDialog: false,
      showUserNick: '',
      imageUrl: this.$store.state.avatar,
      // 昵称
      nickName: '',
      // 设置下拉折叠
      showSet: '',
      wxbdloading: false,
      wechatToken: '', // 绑定微信Token
      wechatCode: '',// 绑定微信二维码
      // 新密码
      newPasswd: {
        new_password: '',
        confirmNewPass: '',
      },
      // 昵称验证规则
      nickNameRules: [{
        required: true,
        trigger: onblur
      }],
      // 密码验证规则
      passwdRules: [{
        required: true,
        trigger: onblur
      }],
      dialogVisibleEmail: false, // 邮箱对话框
      isEmail: !(this.$route.query.isMaster && !this.$store.state.number), // 判断是否是邮箱表格
      // 绑定邮箱表单
      emailForm: {
        email: '',
        code: '',
        type: 'bind'
      },
      // 邮箱验证规则
      emailFormRules: {
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'onBlur'
          },
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱地址',
            trigger: 'onBlur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'onBlur'
          }
        ]
      },
      status: false,
      time: null, // 定时器
      second: 60, // 倒计时
      isDisable: false, // 禁用倒计时按钮
      dialogVisiblePhone: this.$route.query.isMaster && !this.$store.state.number,
      // 手机号对话框
      phoneForm: {
        number: '',
        code: '',
        type: 'bind'
      },
      // 手机号验证规则
      phoneFormRules: {
        number: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'onBlur',
          },
          {
            pattern: /^1[3|4|5|7|8|9]\d{9}$/,
            message: '手机号格式错误',
            trigger: 'onBlur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'onBlur',
          }
        ]
      },
      nc: null,
      yzm_dialogVisible: false,
      showStartBalance:false,
      noticeMsg:{
        noticeSwitch:'',
        email:'',
        package:0,
        balance:'0'
      },
      // 余额报警表单数据
      balanceData: {
        email: '',
        package: 0,
        balance: '0'
      },
      // 余额报警表单验证规则
      balanceRules: {
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        package: [
          {
            required: true,
            message: '请输入点数'
          }
        ],
        balance: [
          {
            required: true,
            message: '请输入余额'
          }
        ]
      },
    }
  },
  components: {
    vueQr
  },
  beforeUpdate() {
    // 判断是否绑定了手机
    if (this.$store.state.number === '') {
      this.showTelDialog = true
      this.showSet = '2'
    }
    this.imageUrl = this.$store.state.avatar
  },
  created() {
    this.getUserData()
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.back()
    },
    copysuccess () {
      this.$toast.success('复制成功')
    },
    // 上传之前的限制函数
    beforeAvatarUpload(file) {
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify({type:'warning', message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'})
        return false
      }
      let size = file.size / 1024 / 1024 / 2
      if (size >= 1) {
        this.$notify({type:'warning', message: '图片大小必须小于等于1M'})
        return false
      }
    },
    // 修改图像
    uploadImg(f) {
      let formdata = new FormData()
      formdata.append('image', f.file)
      this.$http.post('/users/upload_avater', formdata, { 'Content-Type': 'multipart/form-data' }).then(res => {
        if (res.data.status === 'success') {
          this.imageUrl = res.data.data[0]
          this.$store.commit('setOther', {
            name: 'avatar',
            value: res.data.data[0]
          })
          this.$notify({type:'success', message: '修改成功'})
        }
      }).catch(err => {
        this.$notify({type:'danger',message:'网络异常,请稍后再试'})
      })
    },
    // 格式化空格
    formatter(value) {
      return value.replace(/[, ]/g, '')
    },
    // 修改昵称
    updateNickName(nickName) {
      this.$refs.nickNameFormRef
        .validate()
        .then(async () => {
          if (nickName.trim().length > 10) {
            return this.$notify({type:'warning', message: '昵称长度不能超过10'})
          } else if (nickName.trim() === this.$store.state.usernick) {
            return this.$notify({type:'warning', message: '昵称没有变动'})
          }
          // 收起下拉
          this.showUserNick = ''
          try {
            const { data } = await this.$http.post('/users/changenickname', {
              name: nickName,
            })
            if (data.code === 200) {
              this.$notify({type:'success', message: '修改成功'})
              // 清空表单中的数据
              this.nickName = ''
              this.$store.commit('setOther', {
                name: 'usernick',
                value: nickName,
              })
            } else {
              this.$notify({type:'danger', message: data.msg})
              if (data.msg.indexof('未登录') !== -1) {
                await this.$router.push('/login')
              }
            }
          } catch (err) {
            this.$notify({type:'danger',message:'网络异常,请稍后再试'})
          }
        })
        .catch(() => {
        })
    },
    // 修改密码
    updatePasswd(newPasswd) {
      this.$refs.newPasswdFormRef
        .validate()
        .then(async () => {
          const pwd1 = newPasswd.new_password
          const pwd2 = newPasswd.confirmNewPass
          if (pwd1 !== pwd2) {
            return this.$notify({type:'warning', message: '两次密码输入不一样'})
          } else if (pwd1.trim().length < 6 || pwd2.trim().length < 6) {
            return this.$notify({type:'warning', message: '密码长度不能小于6位'})
          } else if (pwd1.trim().length > 18 || pwd2.trim().length > 18) {
            return this.$notify({type:'warning', message: '密码长度不能大于18'})
          }
          try {
            const { data } = await this.$http.post(
              '/users/changePassword',
              qs.stringify(newPasswd)
            )
            this.showSet = newPasswd.new_password = newPasswd.confirmNewPass = ''
            if (data.status === 'success') {
              this.$notify({type:'success', message: data.msg + '即将跳转到登录页面'})
              setTimeout(() => {
                this.$router.push('logout')
              }, 2000)
            } else {
              this.$notify({type:'danger', message: data.msg})
            }
          } catch (err) {
            this.$notify({type:'danger',message:'网络异常,请稍后再试'})
          }
        })
        .catch(() => {
        })
    },
    // 绑定邮箱对话框
    addEmail() {
      this.isEmail = true
      this.dialogVisibleEmail = true
    },

    // 关闭邮箱对话框
    closeEmailDialog(emailref) {
      this.emailForm.email = this.emailForm.code = ''
      this.$refs[emailref].resetValidation('email')
      clearInterval(this.time)
      this.second = 60
      this.status = false
      this.isDisable = false
      this.dialogVisibleEmail = false
    },

    // 绑定邮箱
    bindEmail() {
      this.$refs.emailFormRulesRef.validate().then(async () => {
        this.isDisable = false
        try {
          const { data } = await this.$http.post('/users/changeEmail', this.emailForm)
          if (data.status === 'success') {
            this.$notify({type:'success',message:data.msg})
            this.dialogVisibleEmail = false
            clearInterval(this.time)
            this.second = 60
            this.status = false
            this.$store.commit('setOther', {
              name: 'mail',
              value: this.emailForm.email
            })//绑定邮箱
            this.$refs.emailFormRulesRef.resetValidation('email')
            this.emailForm.email = this.emailForm.code = ''
          } else {
            clearInterval(this.time)
            this.second = 60
            this.status = false
            this.isDisable = false
            this.dialogVisibleEmail = false
            this.$refs.emailFormRulesRef.resetValidation('email')
            this.$notify({type:'danger',message:data.msg})
          }

        } catch (err) {
          clearInterval(this.time)
          this.second = 60
          this.status = false
          this.isDisable = false
          this.$refs.emailFormRulesRef.resetValidation('email')
          this.$notify({type:'danger',message:'网络异常,请稍后再试'})
        }
      }).catch((err)=>{
        this.$notify({type:'danger',message:err[0].message})
      })
    },

    //  获取验证码
    getCode(refRues) {
      let params = ''
      let addAddress = ''
      let ParamsSend = ''
      let rules = ''
      if (this.isEmail) {
        params = 'email'
        addAddress = this.emailForm.email
        ParamsSend = 'Verificationcode/send'
        rules = 'email'
      } else {
        params = 'number'
        addAddress = this.phoneForm.number
        ParamsSend = '/Users/sendCaptcha'
        rules = 'phone'
      }
      this.$refs[refRues].validate(rules).then(async () => {
        const that = this
        const { data } = await this.$http.get('/Users/register_verification')
        if (data == 1) {
          const tcaptcha = new TCaptcha()
          tcaptcha.getTCaptcha(res=>{
            if (res.status == 'error') {
              this.isDisable = false
              return this.$notify({type:'danger',message:'验证失败,请重试'})
            }
            this.yzm_main(ParamsSend, addAddress, res.data[0])
          })
          // 阿里云滑块注释 ↓↓↓
          // this.yzm_dialogVisible = true
          // this.isDisable = true
          // if (this.nc) {
          //   return this.nc.reset()
          // }
          // AWSC.use('nc', function (state, module) {
          //   // 初始化
          //   that.nc = module.init({
          //     // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          //     appkey: 'FFFF0N00000000009A78',
          //     //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
          //     scene: 'nc_other',
          //     // 声明滑动验证需要渲染的目标ID。
          //     renderTo: 'scrollyz',
          //     // test:module.TEST_BLOCK,
          //     //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
          //     success: function (data1) {
          //       that.yzm_dialogVisible = false
          //       that.$http.post('/captcha', {
          //         csessionId: data1.sessionId,
          //         sig: data1.sig,
          //         ctoken: data1.token
          //       }).then(res => {
          //         if (res.data.status == 'error') {
          //           this.isDisable = false
          //           return this.$notify({type:'danger',message:'验证失败,请重试'})
          //         }
          //         that.yzm_main(ParamsSend, addAddress, res.data.data[0])
          //       })
          //     },
          //     // 滑动验证失败时触发该回调参数。
          //     fail: function (failCode) {
          //     },
          //     // 验证码加载出现异常时触发该回调参数。
          //     error: function (errorCode) {
          //       that.isDisable = false
          //       that.yzm_dialogVisible = false
          //       that.$notify({type:'danger',message:'获取验证码失败'})
          //     }
          //   })
          // })
        } else {
          that.yzm_main(ParamsSend, addAddress)
        }
      }).catch((err)=>{
        this.$notify({type:'danger',message:err.message})
      })
    },
    async yzm_main(ParamsSend, addAddress, ctoken) {
      try {
        this.isDisable = true
        const { data } = await this.$http.post(ParamsSend, {
          addAddress,
          type: 'bind',
          ctoken: ctoken
        })
        if (data.status == 'success') {
          this.$notify({type:'success',message:data.msg})
          //  验证通过，显示倒计时
          let that = this
          that.time = setInterval(() => {
            that.status = true
            var second = that.second
            second--
            that.second = second
            if (second === 0) {
              clearInterval(that.time)
              that.second = 60
              that.status = false
              that.isDisable = false
            }
          }, 1000)
        } else {
          this.isDisable = false
          this.$notify({type:'danger',message:data.msg})
        }
      } catch (err) {
        this.$notify({type:'danger',message:'网络异常,请稍后再试'})
      }
    },
    //  绑定手机
    addPhone() {
      this.isEmail = false
      this.dialogVisiblePhone = true
      clearInterval(this.time)
    },

    //  绑定手机对话框确定
    bindPhone() {
      this.$refs.phoneFormRulesRef.validate().then(async ()=> {
          try {
            const { data } = await this.$http.post('/Users/changePhoneNumber', this.phoneForm)
            this.isDisable = false
            if (data.status == 'success') {
              this.$notify({type:'success',message:data.msg})
              this.dialogVisiblePhone = false
              clearInterval(this.time)
              this.second = 60
              this.status = false
              this.$store.commit('setOther', {
                name: 'number',
                value: this.phoneForm.number
              })//绑定邮箱
              this.$refs.phoneFormRulesRef.resetValidation()
            } else {
              clearInterval(this.time)
              this.second = 60
              this.status = false
              this.isDisable = false
              this.$refs.phoneFormRulesRef.resetValidation()
              this.$notify({type:'danger',message:data.msg})
              if (!this.$route.query.isMaster) {
                this.dialogVisiblePhone = false
              }
            }
          } catch (err) {
            clearInterval(this.time)
            this.second = 60
            this.status = false
            this.isDisable = false
            this.$refs.phoneFormRulesRef.resetFields()
            this.$notify({type:'danger',message:'网络异常,请稍后再试'})
          }
      }).catch((err)=>{
        this.$notify({type:'danger',message:err[0].message})
      })
    },

    //  关闭手机对话框取消按钮
    closePhoneDialog() {
      this.phoneForm.number = this.phoneForm.code = ''
      this.$refs.phoneFormRulesRef.resetValidation()
      clearInterval(this.time)
      this.second = 60
      this.status = false
      this.isDisable = false
      this.dialogVisiblePhone = false
    },

    // 绑定微信
    async bindWeChat() {
      this.wxbdloading = true
      this.showWxdialog = true
      try {
        const { data } = await this.$http.post('/oauth/changewechat')
        if (data.status === 'success') {
          this.wechatCode = data.data.url
          this.wechatToken = data.data.token
          this.next()
        } else {
          this.$notify({type:'danger',message:data.msg})
        }
        this.wxbdloading = false
      } catch (err) {
        this.$notify({type:'danger',message:'网络异常,请稍后再试'})
        this.wxbdloading = false
      }
    },
    // 关闭绑定微信对话框
    closeWechat() {
      clearInterval(this.isBindWechat)
    },
    // 刷新微信二维码
    resetWechat() {
      this.bindWeChat() // 手动刷新二维码
      clearInterval(this.isBindWechat)
    },
    //  绑定微信是否成功
    next() {
      try {
        this.isBindWechat = setInterval(async () => {
          const { data } = await this.$http.post('/oauth/changestatus', { token: this.wechatToken })
          if (data.status === 'success') {
            this.showWxdialog = false
            this.$notify({type:'success',message:data.msg})
            clearInterval(this.isBindWechat)
            this.$store.commit('setOther', {
              name: 'wechat_openid',
              value: data.data[0]
            }) //微信openid
          } else {
            if (data.msg.indexOf('已绑定') !== -1) {
              this.$notify({type:'danger',message:data.msg})
              clearInterval(this.isBindWechat)
              this.bindWeChat()
            }
          }
        }, 1000)
      } catch (err) {
        this.$notify({type:'danger',message:'网络异常,请稍后重试'})
        this.bindWeChat()
        clearInterval(this.isBindWechat)
      }

    },
    // 解绑微信
    unBindWeChat() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认解绑微信吗?'
        })
        .then(async () => {
          try {
            const { data } = await this.$http.post('/Users/unbindwechat')
            if (data.status === 'success') {
              this.$notify({type:'success',message:data.msg})
              //微信openid
              this.$store.commit('setOther', {
                name: 'wechat_openid',
                value: '',
              })
            } else {
              this.$notify({type:'danger',message:data.msg})
              if (data.msg.indexof('未登录') !== -1) {
                await this.$router.push('/login')
              }
            }
          } catch (err) {
            this.$notify({type:'danger',message:'网络异常,请稍后再试'})
            await this.$router.push('/login')
          }
        })
        .catch((e) => {
        })
    },
    openBalance(){
      this.showStartBalance = true
    },
    getUserData(){
      this.$http.post('/users/userdata').then(data=>{
        this.noticeMsg = {
          noticeSwitch:data.data.data.notice_switch,
          email:data.data.data.notice_emails,
          package:data.data.data.notice_package,
          balance:data.data.data.notice_balance
        }
      }).catch(err=>{})
    },
    querySearch(querstring, cb) {
      let emailArr = this.$store.state.notice_email
      cb(emailArr)
    },
    selectBalance(email){
      this.balanceData.email = email.email
    },
    closeBalance(){
      this.showStartBalance = false
      this.$refs.balanceRef.resetFields()
    },
    // 开启余额报警
    saveBalanceState(){
      this.$refs.balanceRef.validate(valid=>{
        if(!valid){
          return
        }
        if(this.noticeMsg.email != this.balanceData.email){
          this.$http.post('/Users/notice_email',`value=${this.balanceData.email}`)
            .then(data=>{
              if(data.data.status == 'error'){
                return
              }
              if(data.data == 'success'){
                this.$notify({type:'success',message:data.data.msg})
                this.$store.commit('setOther',{
                  name:'notice_emails',
                  value:this.balanceData.email
                })
              }
              this.getUserData()
            }).catch(err=>{})
        }
        if(this.noticeMsg.package != this.balanceData.package){
          this.$http.post('/Users/notice_package',`value=${this.balanceData.package}`)
            .then(data=>{
              if(data.data.status == 'error'){
                return
              }
              if(data.data == 'success'){
                this.$notify({type:'success',message:data.data.msg})
                this.$store.commit('setOther',{
                  name:'notice_package',
                  value:this.balanceData.package
                })
              }
              this.getUserData()
            }).catch(err=>{})
        }
        if(this.noticeMsg.balance != this.balanceData.balance){
          this.$http.post('/Users/notice_balance',`value=${this.balanceData.balance}`)
            .then(data=>{
              if(data.data.status == 'error'){
                return
              }
              if(data.data == 'success'){
                this.$notify({type:'success',message:data.data.msg})
                this.$store.commit('setOther',{
                  name:'notice_balance',
                  value:this.balanceData.balance
                })
              }
              this.getUserData()
            }).catch(err=>{})
        }

        if(this.$store.state.notice_switch==0){
          this.$http.post('/Users/notice_switch','value=1')
            .then(data=>{
              if(data.data.status == 'error'){
                return this.$notify({type:'danger',message:data.data.msg})
              }
              if(data.data.status == 'success'){
                this.$notify({type:'success',message:data.data.msg})
                this.$store.commit('setOther',{
                  name:'notice_switch',
                  value:1
                })
              }
              this.getUserData()
            }).catch(err=>{})
        }
        this.closeBalance()
      })
    },
    // 开关余量预警
    changeBalanceState(state){
      this.$http.post('/Users/notice_switch',`value=${state}`)
        .then(data=>{
          if(data.data.status == 'error'){
            return this.$notify({
              type:'danger',
              message:data.data.msg
            })
          }
          if(data.data.status == 'success'){
            this.$notify({
              type:'success',
              message:data.data.msg
            })
            this.$store.commit('setOther',{
              name:'notice_switch',
              value:state
            })
          }
          this.getUserData()
        }).catch(err=>{})
    },
  }
}
